'use client';
import { classNames } from '@repo/ui/src/utils/classNames';
import { CarouselProvider, Slider, ButtonBack, ButtonNext } from 'pure-react-carousel';
import Section from '@repo/ui/src/components/Section';
import Quote from './_Quote';
import { LeftArrow, RightArrow } from '../carousels';
import { QuoteProps } from './_Quote';

interface Props {
  quotes: Array<QuoteProps>;
}

const QuoteCarousel = ({ quotes }: Props) => {
  if (!quotes) return null;
  const isInfinite = quotes?.length > 1;
  return (
    <Section
      role="region"
      ariaLabel="quote carousel"
      dark
      butcherPaper
      gutterX
      gutterY
      zIndexNone
      className={classNames(
        'dark-mode quote-carousel tw-flex tw-justify-center tw-overflow-hidden',
        quotes?.length > 1 && 'has-arrows',
      )}
    >
      <CarouselProvider
        naturalSlideWidth={100}
        naturalSlideHeight={200}
        totalSlides={quotes?.length}
        visibleSlides={1}
        className={classNames('tw-flex tw-flex-row tw-justify-center tw-items-center')}
        isIntrinsicHeight
        dragEnabled={false}
        infinite={isInfinite}
      >
        <ButtonBack aria-label="previous" className="tw-h-fit">
          <LeftArrow aria-label={null} />
        </ButtonBack>
        <Slider className="tw-max-w-screen-lg tw-w-full tw-relative">
          {quotes?.map((quote) => <Quote key={quote.text} {...quote} />)}
        </Slider>
        <ButtonNext aria-label="next" className="tw-h-fit">
          <RightArrow aria-label={null} />
        </ButtonNext>
      </CarouselProvider>
    </Section>
  );
};

export default QuoteCarousel;
